/* Inline resource suggestions. Full form submission remains available throughout. */
(() => {
  'use strict';
  let current = null, sequence = 0;
  const cache = new Map();
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const money = cents => new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(cents / 100);
  const fields = document.querySelectorAll('form[data-native-search] input[name="q"]:not([aria-controls])');
  fields.forEach(input => {
    const form = input.form, id = 'cr-quick-' + (++sequence);
    const panel = make('div', 'cr-quick-search');
    const heading = make('div', 'cr-quick-heading');
    const label = make('strong', '', 'Quick results');
    const count = make('span', 'cr-quick-count');
    const list = make('div', 'cr-quick-list');
    const status = make('p', 'cr-quick-status');
    panel.hidden = true;
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Suggested resources');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    heading.append(label, count);
    panel.append(heading, list, status);
    document.body.append(panel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    let timer = 0, version = 0, active = -1, links = [], composing = false;

    const request = () => {
      const params = new URLSearchParams(new FormData(form));
      params.set('q', input.value.trim());
      params.set('type', 'product');
      // The same filters work in both quick results and the full catalogue.
      if (params.get('format')) params.set('filter.p.product_type', params.get('format'));
      const industry = params.get('industry');
      if (industry && /^\d{5}$/.test(params.get('q'))) params.set('q', industry + params.get('q'));
      const url = new URL(form.action, location.origin);
      url.search = params.toString();
      return {params, href: url.href};
    };
    const place = () => {
      if (panel.hidden) return;
      const rect = input.getBoundingClientRect();
      if (!input.getClientRects().length || rect.bottom < 0 || rect.top > innerHeight) { close(); return; }
      const viewport = window.visualViewport;
      const leftEdge = viewport?.offsetLeft || 0, topEdge = viewport?.offsetTop || 0;
      const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
      const panelWidth = Math.min(580, width - 24, Math.max(480, form.getBoundingClientRect().width));
      const left = Math.max(leftEdge + 12, Math.min(rect.left, leftEdge + width - panelWidth - 12));
      const below = topEdge + height - rect.bottom - 16, above = rect.top - topEdge - 16;
      const upward = below < 170 && above > below;
      const available = Math.max(80, upward ? above : below);
      panel.style.width = panelWidth + 'px';
      panel.style.left = left + 'px';
      panel.style.maxHeight = Math.min(570, available) + 'px';
      panel.style.top = (upward ? Math.max(topEdge + 8, rect.top - Math.min(panel.scrollHeight, available) - 8) : rect.bottom + 8) + 'px';
    };
    const close = () => {
      version++;
      clearTimeout(timer);
      panel.hidden = true;
      panel.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
      if (current?.input === input) current = null;
    };
    const open = () => {
      if (current && current.input !== input) current.close();
      current = {input, panel, close, place};
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      place();
    };
    const select = index => {
      active = index;
      links.forEach((link, i) => link.setAttribute('aria-selected', String(i === index)));
      if (index < 0) { input.removeAttribute('aria-activedescendant'); return; }
      input.setAttribute('aria-activedescendant', links[index].id);
      links[index].scrollIntoView({block: 'nearest', behavior: 'instant'});
    };
    const allResults = (href, text) => {
      const link = make('a', 'cr-quick-all', text);
      link.href = href;
      link.id = id + '-all';
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.tabIndex = -1;
      list.append(link);
      links.push(link);
    };
    const render = (result, href) => {
      links = [];
      list.replaceChildren();
      active = -1;
      input.removeAttribute('aria-activedescendant');
      count.textContent = result.total.toLocaleString('en-AU') + (result.total === 1 ? ' match' : ' matches');
      for (const [i, product] of result.items.entries()) {
        const link = make('a', 'cr-quick-item');
        link.id = id + '-' + i;
        link.href = product.url;        link.dataset.selectionProductId=String(product.id);link.dataset.selectionSurface='quick_suggestions';link.dataset.selectionIndex=String(i);link.dataset.selectionFormat=product.type||'';

        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.tabIndex = -1;
        const art = make('span', 'cr-quick-art');
        if (product.image) {
          const image = make('img');
          image.src = product.image;
          image.alt = '';
          image.width = 42;
          image.height = 48;
          art.append(image);
        } else art.textContent = '↗';
        const text = make('span', 'cr-quick-copy');
        const title = make('strong', 'cr-quick-title', product.title);
        const meta = make('span', 'cr-quick-meta');
        const isPreorder = window.CAQA.searchPriority.preorder(product);
        const availability = window.CAQA.searchPriority.statusLabel(product);
        meta.append(make('span', '', product.type), make('span', product.preorder ? 'cr-quick-preorder' : '', availability));
        if (isPreorder) meta.append(make('span', 'cr-quick-enquiry', 'Enquiries: info@caqa.com.au'));
        text.append(title, meta);
        const price = make('div', 'cr-quick-price');
        if (isPreorder) price.textContent = 'Enquire';
        else if (product.price_html) price.innerHTML = product.price_html;
        else price.textContent = money(product.price);
        link.append(art, text, price);
        list.append(link);
        links.push(link);
      }
      allResults(href, result.total ? 'View all ' + result.total.toLocaleString('en-AU') + ' results →' : 'Search the full catalogue →');
      const interpretation=window.CAQA.catalogue.interpretation(new URLSearchParams(new FormData(form)));
      status.textContent = (interpretation.correction?'Showing results for “'+interpretation.correction+'”. ':interpretation.expandedCPR?'Cardiopulmonary resuscitation. ':interpretation.inferredFormat?interpretation.inferredFormat+'. ':'') + (result.items.length ? 'Use ↑ ↓ to choose a resource, then Enter to open it.' : 'No matching resources. Try another code or keyword.');
      panel.removeAttribute('aria-busy');
      open();
    };
    const suggest = async () => {
      const query = input.value.trim();
      if (query.length < 2 || document.activeElement !== input) { close(); return; }
      const run = ++version, {params, href} = request(), key = params.toString();
      links = [];
      active = -1;
      list.replaceChildren();
      count.textContent = '';
      input.removeAttribute('aria-activedescendant');
      allResults(href, 'View full search results →');
      status.textContent = 'Finding matching resources…';
      panel.setAttribute('aria-busy', 'true');
      open();
      try {
        let result = cache.get(key);
        if (!result || Date.now() - result.created > 30000) {
          const catalogue = window.CAQA?.catalogue;
          if (!catalogue) throw Error('Search is still loading');
          // Use the complete index immediately; hydrate candidates to obtain live links,
          // prices and release status without blocking on a full-catalogue refresh.
          const matches = await catalogue.search(params);
          if (run !== version || document.activeElement !== input) return;
          const hydrated = await catalogue.hydrate(matches.slice(0, 18));
          result = {total: matches.length, items: window.CAQA.searchPriority.rank(catalogue.select(hydrated,params),params.get('sort_by')||'relevance').slice(0, 6), created: Date.now()};
          if (cache.size >= 30) cache.delete(cache.keys().next().value);
          cache.set(key, result);
        }
        if (run !== version || document.activeElement !== input) return;
        render(result, href);
      } catch {
        if (run !== version || document.activeElement !== input) return;
        panel.removeAttribute('aria-busy');
        status.textContent = 'Quick results are temporarily unavailable. Use Search to view the full catalogue.';
        place();
      }
    };
    input.addEventListener('input', () => {
      version++;
      clearTimeout(timer);
      select(-1);
      if (input.value.trim().length < 2) { close(); return; }
      // Never leave links for the previous code visible while a new code is typed.
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      if (!composing) timer = setTimeout(suggest, 180);
    });
    input.addEventListener('focus', () => {
      if (input.value.trim().length > 1) { clearTimeout(timer); timer = setTimeout(suggest, 80); }
    });
    input.addEventListener('compositionstart', () => { composing = true; close(); });
    input.addEventListener('compositionend', () => { composing = false; clearTimeout(timer); timer = setTimeout(suggest, 180); });
    input.addEventListener('keydown', event => {
      if (event.isComposing) return;
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); event.stopPropagation(); close(); return; }
      if (event.key === 'Tab') { close(); return; }
      if (panel.hidden || !links.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        select(active < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length);
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        location.assign(links[active].href);
      }
    });
    input.addEventListener('blur', () => setTimeout(() => {
      if (document.activeElement !== input && !panel.contains(document.activeElement)) close();
    }, 0));
    form.addEventListener('submit', close);
    form.addEventListener('change', () => { cache.clear(); if (document.activeElement === input) suggest(); else close(); });
    panel.addEventListener('pointerover', event => {
      const link = event.target.closest('[role="option"]');
      if (link) select(links.indexOf(link));
    });
  });
  document.addEventListener('pointerdown', event => {
    if (current && event.target !== current.input && !current.panel.contains(event.target)) current.close();
  });
  document.addEventListener('focusin', event => {
    if (current && event.target !== current.input && !current.panel.contains(event.target)) current.close();
  });
  addEventListener('resize', () => current?.place());
  addEventListener('scroll', () => current?.place(), {passive: true, capture: true});
  window.visualViewport?.addEventListener('resize', () => current?.place());
  window.visualViewport?.addEventListener('scroll', () => current?.place());
})();
